import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"; //withRouter needed for location & history properties (see readMe)
import { mapDispatchToProps } from "../../redux/actions";
import { completeLogout } from "../../security/IdentityService";
import "../../css/Login.scss";

// expected props
interface IProps {
  history: any;
}
// local state
interface IState {}

class IdentityLogout extends React.Component<IProps, IState> {
  async componentDidMount() {
    await completeLogout();
    this.props.history.push("/");
  }

  public render() {
    return (
      <div className="login-inputs">
        <br />
        <br />
        You are now logged out.
      </div>
    );
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {};
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdentityLogout));
